// fr_pms_common.ts
// Elementy wspólne dla wszystkich ekranów PMS — statusy, akcje, etykiety
// Importuj ten plik w każdym ekranowym pliku tłumaczeń zamiast powielać te same klucze.

export const frPmsCommon = {

  emptyValue: "—",
  yes: "Oui",
  no: "Non",

  roomWithNumber: "Chambre {{number}}",
  counts: {
    rooms_one: "{{count}} chambre",
    rooms_other: "{{count}} chambres",
    nights_one: "{{count}} nuit",
    nights_other: "{{count}} nuits",
    guests_one: "{{count}} client",
    guests_other: "{{count}} clients",
    adults_one: "{{count}} adulte",
    adults_other: "{{count}} adultes",
    children_one: "{{count}} enfant",
    children_other: "{{count}} enfants",
  },

  navigation: {
    rooms: "Rooms & room types",
    "live-board": "Live Board",
    reservations: "Réservations",
    groups: "Groupes et blocs",
    "room-type-availability": "Disponibilité par type de chambre",
    "room-availability-calendar": "Calendrier des chambres",
    guests: "Clients",
    frontdesk: "Réception",
    housekeeping: "Housekeeping",
    billing: "Facturation",
    "night-audit": "Audit de nuit",
    rates: "Tarifs et disponibilités",
    channels: "Canaux",
    reports: "Rapports",
  },
  sidebar: {
    dashboard: "Tableau de bord",
    openModule: "Ouvrir {{module}}",
    openExternal: "Ouvrir {{module}} (externe)",
    openExternalTitle: "Ouvrir {{module}} (externe, nouvel onglet)",
    customize: "Personnaliser la navigation",
    expand: "Développer la navigation",
    collapse: "Réduire la navigation",
    show: "Afficher la navigation",
    hide: "Masquer la navigation",
    description: "Choisir, organiser et développer les modules pour personnaliser leurs sous-sections.",
    closeSettings: "Fermer les paramètres de navigation",
    subsections_one: "{{count}} sous-section",
    subsections_other: "{{count}} sous-sections",
    hideItem: "Masquer {{item}}",
    showItem: "Afficher {{item}}",
    shown: "Visible",
    hidden: "Masqué",
    moveItemUp: "Déplacer {{item}} vers le haut",
    moveItemDown: "Déplacer {{item}} vers le bas",
    moveUp: "Déplacer vers le haut",
    moveDown: "Déplacer vers le bas",
    reset: "Rétablir les valeurs par défaut",
    done: "Terminé",
  },
  workspace: {
    identity: "Gestion des identités",
    settings: "Paramètres",
    language: "Langue",
    languageOptions: "Options de langue",
    active: "Actif",
    darkMode: "Mode sombre",
    logout: "Déconnexion",
    newReservation: "Nouvelle réservation",
    startCheckin: "Commencer l’arrivée",
  },

  // ── Statusy pokoi ──────────────────────────────────────────────────────────
  roomStatus: {
    available:    "Disponible",
    occupied:     "Occupe",
    dirty:        "Sale",
    clean:        "Propre",
    cleaning:     "En nettoyage",
    inspected:    "Inspecte",
    blocked:      "Bloque",
    outOfOrder:   "Hors service",
    outOfService: "Hors service",
    unassigned:   "Non assigne",
    reserved:     "Reserve",
    maintenance:  "En maintenance",
  },

  // ── Statusy rezerwacji ─────────────────────────────────────────────────────
  reservationStatus: {
    confirmed:  "Confirmee",
    inHouse:    "En sejour",
    cancelled:  "Annulee",
    checkedOut: "Depart effectue",
    noShow:     "No-show",
    waitlist:   "Liste d'attente",
    pending:    "En attente",
    planned:    "Planifiee",
    completed:  "Terminee",
    booked:     "Reservee",
    active:     "Active",
    all:        "Toutes",
  },

  roomCalendar: {
    allTypes: "Tous les types",
    allFloors: "Tous les étages",
    floor: "Étage {{floor}}",
    filterByFloor: "Filtrer par étage",
    clearFilters: "Effacer",
    checkedOut: "Départs effectués",
    checkedIn: "Arrivées effectuées",
    cancelledNoShow: "Annulée / Non-présentation",
    showCheckedOut: "Afficher les réservations terminées",
    hideCheckedOut: "Masquer les réservations terminées",
    reservationLegend: "Légende des statuts de réservation et filtre de chambre",
    roomNumberPlaceholder: "N° de chambre",
    searchRoomNumber: "Rechercher un numéro de chambre",
  },

  // ── Ważność / Priorytet ────────────────────────────────────────────────────
  severity: {
    critical: "Critique",
    high:     "Eleve",
    medium:   "Moyen",
    low:      "Faible",
  },

  // ── Przyciski i akcje ──────────────────────────────────────────────────────
  actions: {
    save:        "Enregistrer",
    saving:      "Enregistrement...",
    cancel:      "Annuler",
    cancelling:  "Annulation...",
    close:       "Fermer",
    closing:     "Fermeture...",
    edit:        "Modifier",
    delete:      "Supprimer",
    confirm:     "Confirmer",
    approve:     "Approuver",
    create:      "Creer",
    creating:    "Creation...",
    add:         "Ajouter",
    adding:      "Ajout...",
    back:        "Retour",
    search:      "Rechercher",
    filter:      "Filtrer",
    refresh:     "Actualiser",
    download:    "Telecharger",
    preview:     "Apercu",
    print:       "Imprimer",
    send:        "Envoyer",
    modify:      "Modifier",
    viewAll:     "Tout voir",
    viewDetails: "Voir les details",
    opening:     "Ouverture...",
    set:         "Definir",
  },

  // ── Stany komunikatów ──────────────────────────────────────────────────────
  state: {
    loading:   "Chargement...",
    noData:    "Aucune donnee",
    noResults: "Aucun resultat",
    failed:    "Echec.",
  },

  // ── Wspólne etykiety pól ───────────────────────────────────────────────────
  labels: {
    guest:        "Client",
    guests:       "Clients",
    room:         "Chambre",
    rooms:        "Chambres",
    floor:        "Etage",
    night:        "Nuit",
    nights:       "Nuits",
    checkIn:      "Arrivee",
    checkOut:     "Depart",
    arrival:      "Arrivee",
    departure:    "Depart",
    arrivals:     "Arrivees",
    departures:   "Departs",
    status:       "Statut",
    operations:   "Operations",
    frontDesk:    "Reception",
    occupancy:    "Occupation",
    revenue:      "Revenu",
    billing:      "Facturation",
    housekeeping: "Housekeeping",
    department:   "Departement",
    owner:        "Responsable",
    priority:     "Priorite",
    date:         "Date",
    time:         "Heure",
    total:        "Total",
    notes:        "Notes",
    invoice:      "Facture",
    group:        "Groupe",
    type:         "Type",
    rate:         "Tarif",
    balance:      "Solde",
    amount:       "Montant",
    currency:     "Devise",
    name:         "Nom",
    email:        "Email",
    phone:        "Telephone",
    address:      "Adresse",
    country:      "Pays",
    today:        "Aujourd'hui",
    other:        "Autres",
    none:         "Aucun",
    unassigned:   "Non assigne",
    inHouse:      "En sejour",
    readyRoom:    "Chambre prete",
    noReadyRoom:  "Aucune chambre prete",
  },

} as const;

export default frPmsCommon;
